module.exports = __webpack_public_path__ + "static/media/tnt.1660a45a.png";